export default {
  "lang": "uk",
  "locale_format": "uk-UA",
  "not_enough_data": "Недостатньо даних для побудови графіка",
  "click_mark_to_zoom": "Натисніть на відмітку шкали, щоб збільшити графік",
  "zoom_to_see_more": "Збільште масштаб, щоб побачити решту даних",
  "download_chart_data": "Завантажити дані графіка",
  "switch_to_list_view": "Перемкнути на список",
  "switch_to_map_view": "Перемкнути на карту"
};